import React from 'react';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { ContactUs } from '../organisms/ContactUs';
import { Layout } from '../templates';
import { FormField, useSettings } from '../../stateManagement/SettingsContext';
import { useAuth } from '../../stateManagement/auth/useAuth';
import { BannerWithSearchBar } from '../organisms/BannerWithSearchBar';

export const ContactUsPage: React.FC = () => {
  const { settings, contactUsFormData } = useSettings();
  const { accessToken } = useAuth();

  const { t }: { t: (key: string, options?: { returnObjects: boolean }) => any } = useTranslation();
  const translatedContactUsFormData = t('data.contactUsFormData', { returnObjects: true });
  const helperTexts = t('data.helperTexts', { returnObjects: true });
  const translatedData: FormField[] = Object.values(contactUsFormData ?? {}).map(link => {
    const translation = translatedContactUsFormData.find(
      (i: {
        id: string;
        question?: string;
        description?: string;
        placeholder?: string;
        options?: string;
      }) => i.id === link.id,
    );
    return {
      ...link,
      question: translation?.question ?? link.question,
      description: translation?.description ?? link.description,
      placeholder: translation?.placeholder ?? link.placeholder,
      options: translation?.options ?? link.options,
    };
  });
  const bannerInfo = translatedData.find(item => item.id === 'q1');
  return (
    <Layout showContactUsButton={false} settings={settings}>
      <Helmet>
        <title>Contact Us</title>
      </Helmet>
      <Box backgroundColor={settings?.configs.secondaryBgColor}>
        {/* Banner Component Above the Form */}
        <BannerWithSearchBar
          isFullScreen={settings?.configs.isBannerFullScreen}
          px={{
            base: '0vw',
            md: '0vw',
            lg: settings?.configs.isBannerFullScreen ? '0vw' : '15vw',
          }}
          imageSrc={settings?.configs.contactUsLogo}
          altText="Contact Us Banner"
          bannerText={bannerInfo?.question || 'Get in Touch'}
          subText={bannerInfo?.description || ''}
          showSearchBar={false}
          bannerTextColor="white"
          placeholderText=""
          showOverlay={undefined}
          showJaggedBorder={settings?.configs.showJaggedBorder}
          secondaryAccentColor={settings?.configs.secondaryAccentColor}
          placeholderFontSize={{ base: '20px', md: '22px', lg: '24px' }} // Responsive font size
          placeholderFontWeight="bold"
        />

        <Box
          backgroundColor={settings?.configs.secondaryBgColor}
          bgGradient={`linear(to-b, white 80%, ${settings?.configs.tertiaryAccentColor} 100%)`}
        >
          <ContactUs
            accessToken={accessToken}
            FormFields={translatedData}
            createTicketButtonText={
              helperTexts.find((item: Record<string, string>) => 'createTicketButtonText' in item)
                ?.createTicketButtonText
            }
            liveChatButtonText={
              helperTexts.find((item: Record<string, string>) => 'liveChatButtonText' in item)
                ?.liveChatButtonText
            }
            secondaryAccentColor={settings?.configs.secondaryAccentColor}
            showRocks={settings?.configs.showRocks}
            showJaggedBorder={settings?.configs.showJaggedBorder}
            footerBgColor={settings?.configs.footerBackgroundColor}
            rocksImageUrl={settings?.configs.rocksImageUrl}
            contactUsDisclaimerToastTextColor={settings?.configs.contactUsDisclaimerToastTextColor}
            contactUsDisclaimerToastBgColor={settings?.configs.contactUsDisclaimerToastBgColor}
            contactUsDisclaimerToastText={settings?.data.contactUsDisclaimerToastText}
          />
        </Box>
      </Box>
    </Layout>
  );
};
